'use client';

import { styled } from '../../styles';

export const StyledLayout = styled.div(({ theme }) => ({
  margin: theme.spacing(0, 5),
  width: 'auto',

  [theme.breakpoints.up('sm')]: {
    margin: theme.spacing(0, 7),
    width: 'auto',
  },

  [theme.breakpoints.up('lg')]: {
    margin: theme.spacing(0, 15),
    width: 'auto',
  },

  [theme.breakpoints.up('xl')]: {
    margin: theme.spacing(0, 'auto'),
    width: '1464px',
  },
}));
